import { useCallback } from "react";
import { Button, Col, Col1, Form, Input, TextBody, TextInput } from "../lib";
import { Country, useRequestOtp, useServerForm } from "../services";
import { CountryInput } from "./country-input";

const initialValues = {
  country_code: "TH",
  country_id: 764,
  phone_national: "",
};

type Props = {
  onSuccess?: (
    email: string | null,
    emailVerified: boolean,
    phone: string,
  ) => void;
};

export function LoginForm({ onSuccess }: Props) {
  // Vars
  const [requestOtp, isLoading, error] = useRequestOtp();
  const { values, setValue, setValues } = useServerForm(initialValues, error);

  // Handlers
  const handleChangeCountry = useCallback(
    (country: Country) => {
      setValues({
        country_id: country.id,
        country_code: country.code,
      });
    },
    [setValues],
  );

  const handleSubmit = useCallback(async () => {
    const res = await requestOtp(values);

    if (res) {
      onSuccess?.(res.email, res.email_verified, res.phone);
    }
  }, [onSuccess, requestOtp, values]);

  // Render
  return (
    <Form small>
      <Col1.C>
        <TextBody center mb="6">
          Enter mobile number that you have used to create your Smooci account.
        </TextBody>
        <TextBody center>
          We will send you a SMS with One Time Password (OTP) to use for log in.
        </TextBody>
      </Col1.C>
      <Input label="Phone">
        <CountryInput
          onChange={handleChangeCountry}
          value={values.country_id}
          variant="phone"
        />
        <Col mt="2">
          <TextInput
            name="phone_national"
            value={values.phone_national}
            onChange={setValue}
            placeholder="e.g. 0812345678"
            inputMode="tel"
          />
        </Col>
      </Input>
      <Button em onPress={handleSubmit} loading={isLoading}>
        Request OTP
      </Button>
    </Form>
  );
}
